import { render, staticRenderFns } from "./bolardos.vue?vue&type=template&id=03d543d8&scoped=true&"
import script from "./bolardos.vue?vue&type=script&lang=js&"
export * from "./bolardos.vue?vue&type=script&lang=js&"
import style0 from "./bolardos.vue?vue&type=style&index=0&id=03d543d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d543d8",
  null
  
)

export default component.exports